import { render, staticRenderFns } from "./ClientDocument.vue?vue&type=template&id=9ddf2946&scoped=true"
import script from "./ClientDocument.vue?vue&type=script&lang=js"
export * from "./ClientDocument.vue?vue&type=script&lang=js"
import style0 from "./ClientDocument.vue?vue&type=style&index=0&id=9ddf2946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddf2946",
  null
  
)

export default component.exports